/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
const SettingTab = ({deviceData}) => {
  console.log(deviceData)

  return (
    <>
      <div className='mb-5'>
        <div className='mb-5'>
          <p className='mb-3 fw-semibold fs-5'>Reset Data Recorded : </p>
          <button className='btn btn-danger btn-sm' disabled>
            Reset Data Recorded
          </button>
        </div>

        <div className='mb-5'>
          <p className='mb-3 fw-semibold fs-5'>Reset Device : </p>
          <button className='btn btn-danger btn-sm' disabled>Reset Device</button>
        </div>
      </div>
    </>
  )
}

export {SettingTab}
